import { PayTableCell } from "@lib/titan2-slingo/dist/game/view/abstract/display/PayTableCell";
import { PayTableIcon } from "@lib/titan2-slingo/dist/game/view/abstract/display/PayTableIcon";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
/**
 * GamePayTableCell.ts
 */
export class GamePayTableCell extends PayTableCell {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
    }
    create() {
        if (this.properties.iconProperties) {
            this.icon = new PayTableIcon(this.properties.iconProperties);
            this.addChild(this.icon);
        }
        this.inactiveLabel = TitanText.createField(this, this.properties.inactiveLabelProperties);
        this.inactiveField = TitanText.createField(this, this.properties.inactiveFieldProperties);
        this.inactiveOrField = TitanText.createField(this, this.properties.inactiveOrFieldProperties);
        this.inactiveAltField = TitanText.createField(this, this.properties.inactiveAltFieldProperties);
        this.activeLabel = TitanText.createField(this, this.properties.activeLabelProperties);
        this.activeField = TitanText.createField(this, this.properties.activeFieldProperties);
        this.activeOrField = TitanText.createField(this, this.properties.activeOrFieldProperties);
        this.activeAltField = TitanText.createField(this, this.properties.activeAltFieldProperties);
        this.highlightField = TitanText.createField(this, this.properties.highlightFieldProperties);
        this.highlightOrField = TitanText.createField(this, this.properties.highlightOrFieldProperties);
        this.highlightAltField = TitanText.createField(this, this.properties.highlightAltFieldProperties);
    }
    inactive() {
        this.hideFields();
        TitanText.showField(this.inactiveField);
        TitanText.showField(this.inactiveLabel);
    }
    active() {
        this.hideFields();
        TitanText.showField(this.inactiveField);
        TitanText.showField(this.inactiveLabel);
    }
    current() {
        this.hideFields();
        TitanText.showField(this.activeField);
        TitanText.showField(this.activeLabel);
    }
    highlight() {
        this.hideFields();
        TitanText.showField(this.highlightField);
        TitanText.showField(this.inactiveLabel);
    }
    updateSize(properties) {
        this.properties = properties;
        this.resizeView(this.inactiveLabel, this.properties.inactiveLabelProperties);
        this.resizeView(this.activeLabel, this.properties.activeLabelProperties);
    }
    getProperties() {
        return this.properties;
    }
}
//# sourceMappingURL=GamePayTableCell.js.map